export const errorMessages = {
  400: '(400) Eroare la procesarea cererii.',
  401: '(401) Autentificare esuata.',
  402: '(402) Eroare la procesrea platii.',
  403: '(403) Acces restrictionat.',
  404: '(404) Resursa negasita.',
  405: '(405) Apel nepermis.',
  406: '(406) Raspuns formatat gresit.',
  408: '(408) Timpul alocat operatiunii a fost depasit.',
  409: '(409) Conflict in procesarea cererii.',
  411: '(411) Cererea nu are o lungime definita.',
  422: '(422) Cerere ce nu poate fi procesata.',
  429: '(429) Prea multe cereri.',
  500: '(500) Eroare generala',
  501: '(501) Metoda de procesare neimplementata.',
  502: '(502) Eroare de server.',
  503: '(503) Server indisponibil.'
}



// WEBPACK FOOTER //
// ./src/i18n/index.js